import { createContext } from 'react';
import type { ThreadsApiClient } from './types';

export const ThreadsApiContext = createContext<ThreadsApiClient | null>(null);
